import { buildMenuConfig } from './menuConfig';
import { BUSINESS_FUNCTIONS_SECTION } from './navigation.constants';

/**
 * @param {import('./navigation.constants.js').NavItem[]} menuConfig
 * @param {{ businessFunctionsItems?: import('./navigation.constants.js').NavItem[] }} [options]
 * @returns {import('./navigation.constants.js').NavSection[]}
 */
export function buildMenuSections(menuConfig, options = {}) {
  const find = (key) => menuConfig.find((item) => item.key === key) || null;
  const businessFunctionsItems = options.businessFunctionsItems || [];

  // Flatten Management: section header owns the options (no nested "Management" group).
  const managementItem = find('management');
  const managementItems = (managementItem?.children || []).map((child) => ({
    ...child,
    title: child.title || child.label,
    key: child.key || child.label,
  }));

  return [
    {
      title: 'Dashboard',
      items: [find('dashboard')],
    },
    {
      title: BUSINESS_FUNCTIONS_SECTION,
      items: businessFunctionsItems,
    },
    {
      title: 'General',
      items: [
        find('campaignPlanning'),
        find('campaignExecution'),
      ],
    },
    {
      title: 'Features',
      items: [
        find('intervene'),
        find('flowBuilder'),
        find('templates'),
        find('templateQueue'),
        find('leads'),
        find('sms'),
        find('ecommerce'),
        find('webForm'),
        find('conceptBuilder'),
        find('practiceTest'),
        find('knowledgeMap'),
        find('syllabusBuilder'),
        find('performanceMap'),
        find('parentDashboard'),
        find('teacherDashboard'),
        find('academicDashboard'),
        find('questionbank'),
      ],
    },
    {
      title: 'Report',
      items: [
        find('analytics'),
        // find('reporting'),
      ],
    },
    {
      title: 'Setup',
      items: [find('setupWizard')],
    },
    {
      title: 'Management',
      items: managementItems,
    },
    {
      title: 'Dataset',
      items: [find('entity')],
    },
    {
      title: 'Extra',
      items: [
        find('ai'),
        find('vectorDatabase'),
        find('tools'),
        find('settings'),
        find('machadaloStudio'),
      ],
    },
  ];
}

/**
 * @param {{ isNotProduction?: boolean, businessFunctionsItems?: import('./navigation.constants.js').NavItem[] }} [options]
 */
export function getMenuSections(options = {}) {
  const { businessFunctionsItems, ...menuOptions } = options;
  return buildMenuSections(buildMenuConfig(menuOptions), { businessFunctionsItems });
}
